module.exports = __webpack_public_path__ + "img/2.4a0b2b71.webp";